<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QvR8Sv/tc-custom/9781451640304.jpg?1730521896550" alt="This image is the cover for the book Nightway"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nightway
      </h1>
      <p class="bookDescription body article font2">
        <b>Two brothers, one white, the other half Native American, are rivals for the love of the same woman in this saga from a <i>New York Times</i>–bestselling author.</b><br/><br/>From the ancient way of Arizona’s Navaho nation to the new ranch wealth of the great Southwest, two warring sons fought for one woman’s love.<br/><br/>Lanna’s quiet beauty won the love of two very different men—the “white son” and his half-brother. One, charming, secure in his world and his riches. The other, an outcast of brooding sensuality, proud of his Native American heritage.<br/><br/>Lanna would be forced to choose between them—and between two kinds of life. And even as they fought to possess her, the dark legacy of greed and treachery that lay hidden in their family threatened to destroy her future—and her love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Dailey
      </h2>
      
      <p class="authorDescription body article">Janet Dailey, who passed away in 2013, was born Janet Haradon in 1944 in Storm Lake, Iowa. She attended secretarial school in Omaha, Nebraska, before meeting her husband, Bill. The two worked together in construction and land development until they &ldquo;retired&rdquo; to travel throughout the United States, inspiring Dailey to write the Americana series of romances, setting a novel in every state of the Union. In 1974, Dailey was the first American author to write for Harlequin. Her first novel was <I>No Quarter Asked</I>. She went&#160;on to write approximately ninety novels, twenty-one of which appeared on the <I>New York Times</I> bestseller list. She won many awards and accolades for her work, appearing widely on radio and television. Today, there are over three hundred million Janet Dailey books in print in nineteen different languages, making her one of the most popular novelists in the world. For more information about Dailey, visit www.janetdailey.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33b28299